<template>
  <strong-g><hr /></strong-g>
</template>
